import React from "react"
import { Box, Loader } from "@strapi/design-system"

const ItemCover = ({
  cover,
  name,
  size = 64,
  loading,
}: {
  cover: string
  name?: string
  size?: number
  loading?: boolean
}) => (
  <>
    {cover && cover !== "<nil>" ? (
      <Box
        style={{
          maxWidth: size,
          maxHeight: size,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img alt={name} src={cover} height={size} style={{ maxWidth: size, maxHeight: size }} />
      </Box>
    ) : (
      <Box
        style={{
          width: size,
          height: size,
          maxWidth: size,
          maxHeight: size,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 12,
        }}
      >
        {loading ? <Loader /> : <img alt={"No image"} src={"/none-image.svg"} height={size} />}
      </Box>
    )}
  </>
)

export default ItemCover
